import rpi_revisions from './rpi_revisions';

export default {
  ...rpi_revisions,
};
